// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Rights request types — PDPL / Decree 356 canonical vocabulary.
 *
 * Sprint 43.5.2 unified the RequestType values with PdplRightType
 * (src/shared/src/types/dsr-fulfillment.ts) so the platform speaks a single
 * vocabulary across cases, response templates, seed packs, audit records,
 * and UI. The Phase-1 GDPR-flavoured keys `DSAR`/`RECTIFICATION` were
 * renamed to `ACCESS`/`CORRECTION` and a new `CONSENT_WITHDRAWAL` entry was
 * added to round out the PDPL right set.
 *
 * See: docs/backend/data-model.md, docs/product/phases/phase-1/sprint-1.0.0.md,
 *      docs/compliance/vn-regulator-forms/README.md (PDPL rights spec).
 */
export const RequestType = {
    ACCESS: 'access',
    DELETION: 'deletion',
    CORRECTION: 'correction',
    OBJECTION: 'objection',
    PORTABILITY: 'portability',
    RESTRICTION: 'restriction',
    CONSENT_WITHDRAWAL: 'consent_withdrawal',
};
/** All valid request type values. */
export const ALL_REQUEST_TYPES = Object.values(RequestType);
/**
 * Request type labels for bilingual UI.
 * See: docs/product/phases/phase-1/sprint-1.0.0.md - A.3 Request Types
 */
export const REQUEST_TYPE_LABELS = {
    [RequestType.ACCESS]: {
        en: 'Access (DSAR)',
        vi: 'Yeu cau truy cap du lieu',
    },
    [RequestType.DELETION]: {
        en: 'Deletion',
        vi: 'Yeu cau xoa du lieu',
    },
    [RequestType.CORRECTION]: {
        en: 'Correction / Update',
        vi: 'Yeu cau chinh sua du lieu',
    },
    [RequestType.OBJECTION]: {
        en: 'Objection',
        vi: 'Phan doi xu ly',
    },
    [RequestType.PORTABILITY]: {
        en: 'Data Portability',
        vi: 'Yeu cau chuyen du lieu',
    },
    [RequestType.RESTRICTION]: {
        en: 'Restriction of Processing',
        vi: 'Han che xu ly du lieu',
    },
    [RequestType.CONSENT_WITHDRAWAL]: {
        en: 'Consent Withdrawal',
        vi: 'Rut lai su dong y',
    },
};
//# sourceMappingURL=request-types.js.map